<template>
  <b-card no-body v-if="this.assetMonitoringData">
    <b-card-body>
      <b-container fluid="xl">
        <b-row align-v="center">
          <b-col cols="4">
            <h2>START</h2>
            <div>
              {{ $formatDate(new Date(this.assetMonitoringData.start)) }}
            </div>
            <div>
              <h3>{{ $formatTime(new Date(this.assetMonitoringData.start)) }}</h3>
            </div>
            {{ this.startAddress }}
          </b-col>
          <b-col cols="4" align="center">
            <div v-if="this.assetMonitoringData.controlRoomAlarm">
              <div>
                Control Room
              </div>
              <div>
                <h3>{{ this.assetMonitoringData.controlRoomAlarm.controlRoomIdentifier }}</h3>
              </div>
              <p/>
            </div>
            <div v-if="this.assetMonitoringData.end">
              <div>
                Monitoring duration
              </div>
              <div>
                <h3>{{
                    $formatDuration((new Date(this.assetMonitoringData.end) - new Date(this.assetMonitoringData.start)) / 1000)
                  }}</h3>
              </div>
              <p/>
            </div>
            <div v-if="this.type === 'ASSET' && this.driver">
              <div>
                Driver
              </div>
              <div>
                <router-link :to="{ name: 'driver-detail', params: { type: 'DRIVER', entityId: this.driver.id }}">
                  {{ this.driver.firstName + ' ' + this.driver.lastName }}
                </router-link>
              </div>
              <p/>
            </div>
            <div v-if="this.type === 'DRIVER' && this.asset">
              <div>
                Asset
              </div>
              <div>
                <router-link :to="{ name: 'asset-detail', params: { type: 'ASSET', entityId: this.asset.id }}">
                  {{ this.asset.name }}
                </router-link>
              </div>
              <p/>
            </div>
            <div v-if="this.device">
              <div>
                Device
              </div>
              <div>
                <h3>{{ this.device.name }}</h3>
              </div>
            </div>
          </b-col>
          <b-col cols="4" align="right">
            <div v-if="this.assetMonitoringData.end">
              <h2>END</h2>
              <div>
                {{ $formatDate(new Date(this.assetMonitoringData.end)) }}
              </div>
              <div>
                <h3>{{ $formatTime(new Date(this.assetMonitoringData.end)) }}</h3>
              </div>
              {{ this.endAddress }}
            </div>
            <div style="flex: 1.5;" v-if="!this.assetMonitoringData.end">
              <h2>ACTIVE</h2>
              <p/>
              <base-button size="sm" type="neutral" @click.native="endAssetMonitoring()" style="float: right;">End monitoring</base-button>
            </div>
          </b-col>
        </b-row>
        <p/>
        <div align="center">
          <router-link :to="{ name: 'monitoring', query: { t: assetMonitoringData.accessToken } }" target="_blank">Monitoring view</router-link>
        </div>
        <p/>
        <div align="center">
          <base-button size="sm" type="neutral" @click.native="generateAssetMonitoringToken()">Generate token</base-button>
          <div v-if="token">
            <p/>
            {{ token.accessToken }}
          </div>
        </div>
      </b-container>
    </b-card-body>
  </b-card>
</template>

<script>
import crudApi from "../../crud/crud-api";
import axios from "axios";

export default {
  name: "monitoring-card",
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    assetMonitoringData: {
      type: Object,
      description: "Monitoring data object"
    }
  },
  data: _ => ({
    asset: undefined,
    device: undefined,
    driver: undefined,
    startAddress: undefined,
    endAddress: undefined,
    token: undefined,
  }),
  created() {
    this.loadEntities()
    this.reverseGeocodeData()
  },
  methods: {
    loadEntities() {
      crudApi.getAsset(this.assetMonitoringData.assetId).then(json => this.asset = json.data ? json.data : json)
      crudApi.getDevice(this.assetMonitoringData.deviceId).then(json => this.device = json.data ? json.data : json)
      if (this.assetMonitoringData.driverId) {
        crudApi.getDriver(this.assetMonitoringData.driverId).then(json => this.driver = json.data ? json.data : json)
      }
    },
    endAssetMonitoring() {
      crudApi.endAssetMonitoring(this.assetMonitoringData.id)
    },
    generateAssetMonitoringToken() {
      crudApi.getAssetMonitoringToken(this.assetMonitoringData.id).then(json => this.token = json.data ? json.data : json)
    },
    reverseGeocodeData() {
      if (this.assetMonitoringData.dataPoints !== undefined) {
        this.$reverseGeocode(this.assetMonitoringData.dataPoints[0].location).then(response => {
          this.startAddress = response.data.results[0].formatted_address
        })
      } else {
        this.startAddress = "Unknown"
      }
      if (this.assetMonitoringData.end !== undefined && this.assetMonitoringData.dataPoints !== undefined) {
        this.$reverseGeocode(this.assetMonitoringData.dataPoints[this.assetMonitoringData.dataPoints.length-1].location).then(response => {
          this.endAddress = response.data.results[0].formatted_address
        })
      } else {
        this.endAddress = "Unknown"
      }
    },
  }
}
</script>

<style scoped>

</style>
